<template>
  <div :class="'hexagon hexagon-custom ' + hexagonClass" :style="cssVars">
    <div :class="'hexagon-inner ' + hexagonRowClass" style="cursor: pointer;">
      <div name="contador_hexagonal" class="contador-hexagon">{{contador}}</div>
      <p class="hexagon-metric-label mb-0">
        {{ title }}
      </p>
    </div>
    <small v-if="description" class="hexagon-description">{{ description }}</small>
  </div>
</template>

<script>
export default {
  name: "vnsHexagonSubtitle",
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    hexagonClass: {
      type: String,
      default: ''
    },
    hexagonRowClass: {
      type: String,
      default: ''
    },
    contador: {
      type: Number,
      default: 0
    }
  },
  computed: {
    cssVars() {
      return {
        '--custom-background-color': this.customBackgroundColor,
        '--custom-color': this.customColor
      }
    }
  },
  data() {
    return {
      customBackgroundColor: '#f8f9fc',
      customColor: '#000'      
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>

$primary: #4e73df;
$success: #1cc88a;
$warning: #f6c23e;
$danger: #e74a3b;
$secondary: #858796;
$dark: #5a5c69;

.hexagon-description {
  position: absolute;
  top: calc(100% + 42px);
  left: 50%;
  transform: translateX(-50%);
  width: 140px;
  text-align: center;
  font-size: 11px;
  color: $dark;
  line-height: 1.3;
  z-index: 1;
}

.hexagon-custom {
  background-color: var(--custom-background-color);
  color: var(--custom-color);

  &:before {
    border-bottom: 40.41px solid var(--custom-background-color);
  }

  &:after {
    border-top: 40.41px solid var(--custom-background-color);
  }
}

/* Hexagon */
.hexagon {
  position: relative;
  width: 140px;
  height: 80.83px;
  margin: 44px 2px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  &:before, &:after {
    content: "";
    position: absolute;
    width: 0;
    border-left: 70px solid transparent;
    border-right: 70px solid transparent;
  }

  &:before {
    bottom: 100%;
  }

  &:after {
    top: 100%;
    width: 0;
  }
}

/* Inner Hexagon */
.hexagon-inner {
  width: 136px;
  height: 78.52px;
  margin: 39.26px 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;

  &:before, &:after {
    content: "";
    position: absolute;
    width: 0;
    border-left: 68px solid transparent;
    border-right: 68px solid transparent;
    z-index: 1;
  }

  &:before {
    bottom: 100%;
    border-bottom: 39.26px solid transparent;
  }

  &:after {
    top: 100%;
    width: 0;
    border-top: 39.26px solid transparent;
  }
}

/* Metric */
.hexagon-metric-label {
  width: 134px;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  z-index: 1;
}

.contador-hexagon {
    font-size: 45px;
    color: black;
    background: rgb(245, 245, 245 / 0.90);
    border-width: 1px 1px 0 1px;
    border-color: black;
    border-style: solid;
    font-family: 'digital-clock-font'!important;
    width: 100px;
    height: 65px;
    margin-top: 0px;
    margin-bottom: 0px;
    border-radius: 10px;
    box-shadow: rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
}

.row-primary > .contador-hexagon {
    color: $primary;
    border: 1px solid $dark;
}

.row-success > .contador-hexagon {
    color: $success;
    border: 1px solid $dark;
}

.row-warning > .contador-hexagon {
    color: $warning;
    border: 1px solid $dark;
}

.row-danger > .contador-hexagon {
    color: $danger;
    border: 1px solid $dark;
}

.row-secondary > .contador-hexagon {
    color: $secondary;
    border: 1px solid $dark;
}
</style>
